import type { Registry as Interface, RegistryService } from "../../design/services";
import type { Config } from "../../design/types";

export type ServiceMethods = Record<string, (params: unknown) => Promise<unknown>>;

export abstract class Registry implements Interface {
    protected services = new Map<string, ServiceMethods>();

    constructor(_config: Config) {}

    ["constructor"](_config: Config): Registry {
        throw new Error("Use new Registry(config) instead");
    }

    get(name: string): ServiceMethods | undefined {
        return this.services.get(name);
    }

    abstract set(service: RegistryService): Promise<void>;
}
